import React from "react";
import { useRef, useEffect, useState } from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import Typography from '@mui/material/Typography';
import {PulseLoader } from "react-spinners";
import CardMedia from '@mui/material/CardMedia';

const StepOne = (props) => {

     const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  };

   return (
   <div className="booking-portal-step-wrapper">
    <section>
      <div className="service-wrapper">
        <h2 className="grid-title">Choose A Service</h2>
        <div style={{display:'flex', justifyContent:'center', alignItems: 'center'}}>
          <div style={{marginTop:"2rem"}}>
            <PulseLoader
              color={'#333'}
              loading={props.services == 'waiting'}
              size={25}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        </div>
        <div className="service-list">
          {props.services == 'waiting' ? <></>
          :
         (props.services == null || props.serviceDurations == null) ? <div className="service-info">No services</div>:
         <div>
          {props.services.map((service, idx) => (
            <div className="service-card" key={idx}>
              <div className="service-content">
                <div className="service-info">
                  <h3>{service.name}</h3>
                  <p>{props.serviceDurations.filter(item => item.value === service.duration)[0].label}</p>
                  <p>£{Number(service.price/100).toFixed(2)}</p>
                  <button
                    className="toggle-btn"
                    onClick={() => toggle(idx)}
                    aria-expanded={openIndex === idx}
                  >
                    {openIndex === idx ? "▲ Less Info" : "▼ More Info"}
                  </button>
                  <div className={`description ${openIndex === idx ? "expanded" : ""}`}>
                    <p>{service.description}</p>
                  </div>
                </div>
              <div className="image-wrapper">
                <button onClick={() => {props.handleServiceSelected(service); props.goTo(1); props.getBarbers(service);}} className="select-btn"
                  >Book</button>
                {service.filename && (
                  <img
                    src={process.env.REACT_APP_API_SERVICE_BASE_URL +'image/' + "ServiceImages/" + service.filename}                    
                    className="service-image"
                  />
              )}            
            </div>
          </div>
        </div>
      ))}
    </div>     
    }
    </div>
    </div>
  </section>
</div>
   );
};

export default StepOne;


        //  props.services.map((service, index) => (
        //  <div key={index} className='col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4'>
        //     <Card>
        //        <CardActionArea onClick={() => {props.handleServiceSelected(service); props.goTo(1); props.getBarbers(service);}}>
        //           <CardMedia
        //           component="img"
        //           style={{width:"7rem", marginLeft:"auto", borderRadius:"5%", marginRight:"auto"}}
        //           image={process.env.REACT_APP_API_SERVICE_BASE_URL +'image/' + "ServiceImages/" + service.filename}
        //           alt=""
        //           className="mt-3 img-fluid"
        //           />
        //           <CardContent>
        //              <Typography gutterBottom variant="h5" component="div" style={{textAlign: "center"}}>
        //                 {service.name}
        //              </Typography>
        //              <Typography gutterBottom variant="p" component="div" style={{textAlign: "center"}}>
        //                 {props.serviceDurations.filter(item => item.value === service.duration)[0].label}
        //              </Typography>
        //              <Typography gutterBottom variant="p" component="div" style={{textAlign: "center"}}>
        //                 £{Number(service.price/100).toFixed(2)}
        //              </Typography>
        //              <Typography gutterBottom variant="p" component="div" style={{textAlign: "center", fontSize:"0.8rem", color:"#a8a8a8"}}>
        //                 {((service.onlinePaymentAmount === null) ||  (service.onlinePaymentAmount === 0.00) || (props.acceptingOnlinePayments === false)) ? <br></br> : "Payment required now" }
        //              </Typography>
        //           </CardContent>
        //        </CardActionArea>
        //     </Card>
        //  </div>
        //  ))